var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisible(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 14.771,
    viewBox: "0 0 20 14.771",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-hide-5584573",
    transform: "translate(161)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16051",
    "data-name": "Group 16051"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17362",
    "data-name": "Group 17362",
    transform: "translate(-161)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16050",
    "data-name": "Group 16050"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_235908",
    "data-name": "Path 235908",
    d: "M122.487,268.05c-5.442,0-9.687,6.632-9.865,6.915a.892.892,0,0,0,0,.942c.178.283,4.423,6.915,9.865,6.915s9.687-6.632,9.865-6.915a.892.892,0,0,0,0-.942C132.174,274.682,127.929,268.05,122.487,268.05Zm0,13.1c-3.863,0-7.241-4.27-8.273-5.716,1.033-1.446,4.41-5.717,8.273-5.717s7.241,4.27,8.273,5.717C129.727,276.881,126.35,281.152,122.487,281.152Z",
    transform: "translate(-112.487 -268.05)",
    fill: "#07B4E8"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_235909",
    "data-name": "Path 235909",
    d: "M426.55,422.05a4.5,4.5,0,1,0,4.5,4.5A4.5,4.5,0,0,0,426.55,422.05Zm0,7.1a2.6,2.6,0,1,1,2.6-2.6A2.606,2.606,0,0,1,426.55,429.152Z",
    transform: "translate(-416.551 -419.164)",
    fill: "#07B4E8"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisible);
export default __webpack_public_path__ + "static/media/visible.3522317569c030c1f037f0ffb36c953b.svg";
export { ForwardRef as ReactComponent };